<script lang="ts">
    import { uistate } from "../../../../../../store/uisstate";

    export let row;
    export let onSelectChange;
    export let col;
    export let idKey;
    export let storeKey;
    $: checked = $uistate[storeKey].find(
        (selected) => selected[idKey] === row[idKey]
    );
</script>

<div>
    <input
        type="checkbox"
        on:change={() => {
            uistate.update((uistate) => {
                return {
                    ...uistate,
                    [storeKey]: uistate[storeKey].find(
                        (selectedRow) => selectedRow[idKey] === row[idKey]
                    )
                        ? uistate[storeKey].filter(
                              (selectedRow) => row[idKey] !== selectedRow[idKey]
                          )
                        : uistate[storeKey].concat([row]),
                };
            });
        }}
        bind:checked
    />
</div>

<style>
    div {
        display: flex;
        justify-content: center;
        flex-flow: column;
        height: 100%;
        text-align: center;
        vertical-align: middle;
        padding: 0 1.5rem;
    }
</style>
